import React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Badge, List, Typography } from 'antd';

import { ENotificationType } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

export default function BankslipGenerated() {
  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);
  const bankslips = notifications?.find(notification => notification.type === ENotificationType.BANKSLIP_GENERATED);

  if (!bankslips?.quantity) return null;

  const quantity = bankslips.quantity || 0;

  return (
    <Link to={`/producer/notifications/${ENotificationType.BANKSLIP_GENERATED}`}>
      <List.Item extra={<Badge count={quantity} color='blue' showZero />}>
        <Typography.Text strong>Boletos Gerados</Typography.Text>
      </List.Item>
    </Link>
  );
}
